import React, { useEffect, useRef } from "react";
import HomeIntroSection from "./home/HomeIntroSection";
import ExamChoicesSection from "./home/ExamChoicesSection";
import GetStartedSection from "./home/GetStartedSection";
import { useNavigate } from "react-router-dom";

function Home() {
    const examChoicesSection = useRef(null);
     const navigate = useNavigate();

    useEffect(() => {
        navigate("/exam-papers");
    }, [navigate]);
    

    const scrollDown = (ref) => {
        window.scrollTo({
            top: ref.current.offsetTop,
            behavior: 'smooth',
        });
    };

    return (
        <>
            <HomeIntroSection onClick={() => scrollDown(examChoicesSection)} />
            <ExamChoicesSection ref={examChoicesSection} />
            <GetStartedSection  />
        </>
    );
}

export default Home;
